/**
 * ROUTE RESETTER
 * Reset the active item
 * Pass the id of the query to set active if defined
 */
import establishmentStore from "@/entities/establishment/model/establishment.store"
import { useLayoutEffect } from "react"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"

export default function RouteResetter() {
  const dispatch = useDispatch()
  const location = useLocation()

  //Les pages de detail lisent l'item actif depuis leur param d'URL : les reinitialiser les casserait.
  //useLayoutEffect : le reset doit etre applique avant le premier paint, sinon la page affiche
  //brievement l'etat de la page precedente (ou son placeholder) avant de se corriger.
  useLayoutEffect(() => {
    if (/^\/risks\/(phy|rps|populations|sites)\/[^/]+$/.test(location.pathname)) return
    dispatch(establishmentStore.thunks.resetActiveItems(location.search))
  }, [dispatch, location.pathname, location.search])

  return null
}
